const COLOR_STOPS = [
  { t: 0, r: 33, g: 150, b: 243 },
  { t: 0.2, r: 0, g: 188, b: 212 },
  { t: 0.4, r: 76, g: 175, b: 80 },
  { t: 0.65, r: 255, g: 235, b: 59 },
  { t: 0.82, r: 255, g: 152, b: 0 },
  { t: 1, r: 244, g: 67, b: 54 },
];

function interpolateRainColor(mm, maxMm) {
  const ratio = Math.max(0, Math.min(1, mm / Math.max(maxMm, 1)));
  let lower = COLOR_STOPS[0];
  let upper = COLOR_STOPS[COLOR_STOPS.length - 1];

  for (let index = 0; index < COLOR_STOPS.length - 1; index += 1) {
    if (ratio >= COLOR_STOPS[index].t && ratio <= COLOR_STOPS[index + 1].t) {
      lower = COLOR_STOPS[index];
      upper = COLOR_STOPS[index + 1];
      break;
    }
  }

  const span = upper.t - lower.t || 1;
  const localT = (ratio - lower.t) / span;

  return {
    r: Math.round(lower.r + (upper.r - lower.r) * localT),
    g: Math.round(lower.g + (upper.g - lower.g) * localT),
    b: Math.round(lower.b + (upper.b - lower.b) * localT),
  };
}

export function rainMmToRgba(mm, maxMm, alpha) {
  const color = interpolateRainColor(mm, maxMm);
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;
}

export function rainMmToHex(mm, maxMm) {
  const color = interpolateRainColor(mm, maxMm);
  const toHex = (value) => {
    const hex = value.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
  };
  return `#${toHex(color.r)}${toHex(color.g)}${toHex(color.b)}`;
}

export function renderRainHeatmapCircles(maps, map, heatPoints, maxMm) {
  if (!maps || !map || !Array.isArray(heatPoints)) {
    return [];
  }

  return heatPoints
    .map((point) => {
      const mm = Number(point.mm) || 0;
      if (mm <= 0) return null;

      const intensity = mm / Math.max(maxMm, 1);

      return new maps.Circle({
        map,
        center: { lat: point.lat, lng: point.lng },
        radius: 70 + intensity * 95,
        fillColor: rainMmToHex(mm, maxMm),
        fillOpacity: 0.38 + intensity * 0.24,
        strokeWeight: 0,
        clickable: false,
        zIndex: 0,
      });
    })
    .filter(Boolean);
}

export function clearRainHeatmapCircles(circles) {
  (circles || []).forEach((circle) => circle.setMap(null));
}
